var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2918_81848)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#F2F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81311 11.0202L1.64645 13.1869C1.55268 13.2807 1.5 13.4078 1.5 13.5404V17.9C1.5 18.1761 1.72386 18.4 2 18.4H17C17.2761 18.4 17.5 18.1761 17.5 17.9V13.5404C17.5 13.4078 17.4473 13.2807 17.3536 13.1869L12.5202 8.35355C12.325 8.15829 12.0084 8.15829 11.8131 8.35355L7.18689 12.9798C6.99162 13.175 6.67504 13.175 6.47978 12.9798L4.52022 11.0202C4.32496 10.825 4.00838 10.825 3.81311 11.0202Z",
    fill: "#7B8CC8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6,
    r: 2,
    fill: "#7B8CC8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 1.5,
    stroke: "#7B8CC8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2918_81848"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.faf8625237623049737a5210c158b736.svg";
export { ForwardRef as ReactComponent };